var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var debounce = require('debounce');

function HeroSlider(el, indicators) {
  this.$el = $(el);
  this.$indicators = $(indicators);
  this.$slides = this.$el.children('[data-slide]');
  this.activeIndex = 0;
  this.sliding = false;

  $(window).on('vsc-page-resized', this.resize.bind(this));
  this.resize();

  this.$el.on('click', '[data-slide-control="next"]', this.nextSlide.bind(this));
  this.$el.on('click', '[data-slide-control="previous"]', this.previousSlide.bind(this));

  if(this.$indicators.length) {
    this.$indicators.on('click', function(event) {
      event.preventDefault();

      var $indicator = $(event.currentTarget);
      var index = $indicator.index();

      var left = (index < this.activeIndex);

      this.goTo(index, left);
    }.bind(this));
  }

  this.$el.on('scroll-in.vsc-scroll', function() {
    this.$el.find('[data-slide].active').trigger('slide-in.vsc-slide');
  }.bind(this));
}

HeroSlider.prototype.goTo = function(index, left) {
  if(this.sliding || index === this.activeIndex) {
    return;
  }

  // if(typeof left === 'undefined') {
  //   left = (index < this.activeIndex);
  // }

  this.slideOut(this.activeIndex, left);
  this.slideIn(index, left);
  this.activeIndex = index;

  if(this.$indicators.length) {
    var $i = this.$indicators.eq(index);
    $i.addClass('active');
    this.$indicators.not($i).removeClass('active');
  }
}

HeroSlider.prototype.nextSlide = function() {
  if(this.sliding) {
    return;
  }

  if(this.activeIndex >= this.$slides.length - 1) {
    this.goTo(0);
  } else {
    this.goTo(this.activeIndex+1);
  }
}

HeroSlider.prototype.previousSlide = function() {
  if(this.sliding) {
    return;
  }

  if(this.activeIndex == 0) {
    this.goTo(this.$slides.length - 1, true);
  } else {
    this.goTo(this.activeIndex-1, true);
  }
}

HeroSlider.prototype.resize = function() {
  var maxHeight = 0;

  this.$slides.each(function() {
    maxHeight = Math.max(maxHeight, $(this).find('[data-slide-content]').outerHeight());
  }).css('height', maxHeight);
}

HeroSlider.prototype.slideOut = function(index, left) {
  var $slide = this.$slides.eq(index);
  var $slideBackground = $slide.find('.hero-slide-background');
  var $slideContent = $slide.find('.centered-container');

  if(!left) {
    $slide.addClass('prev').trigger('slide-out.vsc-slide');
  } else {
    this.sliding = true;

    $slide.addClass('next');

    TweenLite.fromTo($slideBackground, .35, {
      y: '0%'
    }, {
      y: '-100%',
      ease: Power3.easeIn,
      onComplete: function() {
        this.$slides.removeClass('prev next');

        $slide.trigger('slide-out.vsc-slide');

        this.sliding = false;
      }.bind(this),
      clearProps: 'y'
    });
  }
}

HeroSlider.prototype.slideIn = function(index, left) {
  var $slide = this.$slides.eq(index);
  var $slideBackground = $slide.find('.hero-slide-background');
  var $slideContent = $slide.find('.centered-container');

  if(!left) {
    this.sliding = true;

    $slide.addClass('active next');
    this.$slides.not($slide).removeClass('active');

    TweenLite.fromTo($slideBackground, .6, {
      y: '-100%'
    }, {
      y: '0%',
      ease: Bounce.easeOut,
      delay: .15,
      onComplete: function() {
        this.$slides.removeClass('prev next');

        $slide.trigger('slide-in.vsc-slide', {index: $slide.index(this.$slides)});

        this.$slides.not($slide).removeClass('active');

        this.sliding = false;
      }.bind(this),
      clearProps: 'y'
    });
  } else {
    $slide.addClass('active prev');
    this.$slides.not($slide).removeClass('active');
  }
}

module.exports = HeroSlider;